module.exports = __webpack_public_path__ + "static/img/award5.c63d82a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/award5.png
// module id = M4NH
// module chunks = 0